import { api } from '../index';
import { objectToFormData } from '@/api/util';

const prefix = '/api/item/item_class/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectItemClassList(param) {
	return api.post(prefix + 'selectItemClassList', param);
}

export function apiSelectFobPriceList(param) {
	return api.post(prefix + 'selectFobPriceList', param);
}

export function apiSelectItemClass(param) {
	return api.post(prefix + 'selectItemClass', param);
}

export function apiSelectNewAutoClassCode(param) {
	return api.post(prefix + 'selectNewAutoClassCode', param);
}

export function apiCheckItemClassExists(param) {
	return api.post(prefix + 'checkItemClassExists', param);
}

export function apiInsertItemClass(param) {
	param.mode = 'insert';
	return apiSubmitItemClass(param);
}

export function apiUpdateItemClass(param) {
	param.mode = 'update';
	return apiSubmitItemClass(param);
}

export function apiClearWhCode(param) {
	return api.post(prefix + 'clearWhCode', param);
}

export function apiSetNewWhCode(param) {
	return api.post(prefix + 'setNewWhCode', param);
}

export function apiDeleteItemClass(param) {
	param.mode = 'delete';
	return apiSubmitItemClass(param);
}

function apiSubmitItemClass(param) {
	return api.post(prefix + 'submitItemClass', param);
}

export function apiUpdateSoBlockItemClasses(param) {
	return api.post(prefix + 'updateSoBlockItemClasses', param);
}

export function apiUpdateDesignatedItemClasses(param) {
	return api.post(prefix + 'updateDesignatedItemClasses', param);
}

export function apiInsertPicture(param) {
	return api.post(prefix + 'insertPicture', param);
}

export function apiDeletePicture(param) {
	return api.post(prefix + 'deletePicture', param);
}

export function apiInsertExtraImage(param) {
	return api.post(prefix + 'insertExtraImage', param);
}

export function apiDeleteExtraImage(param) {
	return api.post(prefix + 'deleteExtraImage', param);
}

export function apiSelectExtraImageList(param) {
	return api.post(prefix + 'selectExtraImageList', param);
}

export function apiSelectItemClassStartWithKeyword(start_with_keyword) {
	return api.get(prefix + 'selectItemClassStartWithKeyword', { params: { start_with_keyword } });
}

export function apiSelectItemClassByStringRange(from_item_class, to_item_class) {
	return api.get(prefix + 'selectItemClassByStringRange', { params: { from_item_class, to_item_class } });
}

export function apiAllItemClassesWHColorCode() {
	return api.put(prefix + 'allItemClasses/whColorCode');
}

export function apiSelectLocationByClass(class_list) {
	return api.post(prefix + 'selectLocationByClass', objectToFormData({ class_list }));
}
